// extracted by mini-css-extract-plugin
export default {"password":"uKITDa","captcha":"wvT8hb","submitButton":"IhtFvs","resetPassword":"Yl2grR","divider":"Vtbm4X","ctaHeader":"JywtfM","signup":"czAy5D","form":"pySolN"};